import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-top: 16px;
    border-top: 1px solid #f1f5f9;
    &:first-child {
        padding-top: 0;
        border-top: none;
    }
`;

const Head = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const TitleIcon = styled.img`
    width: 18px;
    height: 18px;
    flex: none;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 0.85rem;
    font-weight: 700;
    color: #0f172a;
    font-family: "Inter", system-ui, sans-serif;
`;

const Description = styled.p`
    margin: 0;
    font-size: 0.78rem;
    color: #64748b;
    font-family: "Inter", system-ui, sans-serif;
`;

// One block inside a FormSection, for a section that holds several things a reader would otherwise
// take for three unrelated sections.
export const SubSection = ({ label, icon, description, children }) => (
    <Wrap role="group" aria-label={label}>
        <Head>
            <TitleRow>
                {icon && <TitleIcon src={icon} alt="" />}
                <Title>{label}</Title>
            </TitleRow>
            {description && <Description>{description}</Description>}
        </Head>
        {children}
    </Wrap>
);
